const OlyAnimate = {
    targets: [],
    elementInView : (el, percentageScroll = 100) => {
        const elementTop = el.getBoundingClientRect().top;

        return (
            elementTop <=
            ((window.innerHeight || document.documentElement.clientHeight) * (percentageScroll/100))
        );
    },
    handleScrollAnimation: () => {
        Array.from(OlyAnimate.targets).forEach((el) => {
            const options = OlyAnimate.getOptions(el);
            OlyAnimate.setDuration(el,options);
            OlyAnimate.setDelay(el,options);
            OlyAnimate.bindAnimationByType(el,options);
        })
    },
    bindAnimationByType: (el,options) => {
        switch (options.type) {
            case 'reveal':
                OlyAnimate.handleRevealAnimation(el,options);
                break;
            case 'text':
                OlyAnimate.handleTextAnimation(el,options);
                break;
            default:
                OlyAnimate.handleRevealAnimation(el,options);
                break;
        }
    },
    handleTextAnimation: (el,options) => {
        if (OlyAnimate.elementInView(el, 100)) {
            el.classList.add(options.in)
        } else {
            el.classList.remove(options.in)
        }
    },
    handleRevealAnimation: (el,options) => {
        const outAnimation = 'out' in options ? options.out : 'oly-slide-out-left';
        const inAnimation = 'in' in options ? options.in : 'oly-slide-in-left';
        if (OlyAnimate.elementInView(el, 100)) {
            el.classList.remove(outAnimation)
            el.classList.add(inAnimation)
        } else {
            el.classList.remove(inAnimation)
            el.classList.add(outAnimation)
        }
    },
    setDuration: (el,options) => {
        let duration = options.duration ? options.duration / 1000 : '0.75';
        el.style.animationDuration = duration+'s';
    },
    setDelay: (el,options) => {
        let delay = options.delay ? options.delay / 1000 : '0';
        el.style.animationDelay = delay+'s';
    },
    getOptions: el => {
        return JSON.parse(el.getAttribute('data-oly-animate').replaceAll("'", '"'))
    },
    bindWindowScrollListener: _ => {
        window.addEventListener('scroll', () => {
            OlyAnimate.handleScrollAnimation();
        })
    },
    setTargets: _ => {
        OlyAnimate.targets = document.querySelectorAll('[data-oly-animate^="{"]');
    },
    init: _ => {
        OlyAnimate.setTargets();
        if (OlyAnimate.targets.length){
            OlyAnimate.bindWindowScrollListener()
        }
    }
}

OlyAnimate.init();
